import { createContext } from 'react';
const DEFAULT_BASE_URL = 'https://www.coinbase.com';
const COINBASE_ACCOUNTS_DEFAULT_BASE_URL = 'https://accounts.coinbase.com';
const UrlContext = /*#__PURE__*/createContext({
  baseUrl: DEFAULT_BASE_URL,
  coinbaseAccountsBaseUrl: COINBASE_ACCOUNTS_DEFAULT_BASE_URL
});
export { COINBASE_ACCOUNTS_DEFAULT_BASE_URL, DEFAULT_BASE_URL, UrlContext as default };
//# sourceMappingURL=UrlContext.js.map
